function callbackDefer(currentElem){
            (window.findifyCallbacks = window.findifyCallbacks || []).push(function (findify) {               
                  var widgetConfiguration = { appendTo: 'findify-widget-2', key: 2 };
                  window.findify.widgets.attach('.findify-widget-2', 'autocomplete', widgetConfiguration);
                }, function (findify) {
                  window.findify.listen(function(event, widget) {                   
                    
                    if (event === 'attachWidget' && widget.type === "autocomplete" && widget.key === 2){
                    if($(currentElem).hasClass('search-icon')){
                        currentElem = $(".dropdown-grid-search input[type='search']");  
                    }                       
                        $(currentElem).blur();  
                        setTimeout(function () {
                            $(currentElem).focus();             
                            $("#fakeinput").remove();

                            function findifyWidgetObs(target){

                                var target = document.querySelector(target);
                                // create an observer instance
                                var observer = new MutationObserver(function(mutations,observer) {
                                  mutations.forEach(function(mutation) {
                                        $(".dropdown-grid-search #findify-loader").addClass("hidden");
                                        $(".header_top .location-information .fixed-search #findify-loader").addClass("hidden");
                                  });
                                    // later, you can stop observing
                                    observer.disconnect();
                                });
                                // configuration of the observer:
                                var config = { attributes: true};
                                // pass in the target node, as well as the observer options
                                observer.observe(target, config);


                            }

                            findifyWidgetObs('.findify-widget-2');
                            findifyWidgetObs('.findify-widget-4');

                        }, 400);
                    }
                  });
                });
}

function headerSeachBar(currentElem,callbackDefer){

    const existingScript = document.getElementById('findify-custom');
    if (!existingScript) {
        //$(".header_top .location-information .fixed-search #findify-loader").removeClass("hidden");
        var script = document.createElement("script");
        var apiLocal = "//assets.findify.io/appliance-canada-test.myshopify.com.min.js";
        var apiProd = "//assets.findify.io/appliancecanada.myshopify.com.min.js";
        var finalApi = apiProd
        if(window.location.hostname === "www.appliancecanada.com" || window.location.hostname === "appliancecanada.com" || window.location.hostname === "appliancecanada.myshopify.com" || window.Shopify.shop === "appliancecanada.myshopify.com")
        {
            finalApi = apiProd;    
        }
        else if(window.Shopify.shop === "appliance-canada-test.myshopify.com")
        {
            finalApi = apiLocal;
        }
        script.type = "text/javascript";
        script.async = true;
        script.id = "findify-custom"
        script.src = finalApi; 
        document.getElementsByTagName("footer")[0].appendChild(script);
            if(window.navigator.userAgent.indexOf("Mac") != -1){
        
                const fakeInput = document.createElement('input');
                  fakeInput.setAttribute('type', 'text');
                  fakeInput.style.position = 'absolute';
                  fakeInput.style.opacity = 0;
                  fakeInput.style.height = 0;
                  fakeInput.id = "fakeinput";
                  fakeInput.style.fontSize = '16px'; // disable auto zoom

                  // you may need to append to another element depending on the browser's auto 
                  // zoom/scroll behavior
                  document.querySelector(".dropdown-grid-search input[type='search']").parentNode.appendChild(fakeInput);
              

                  // focus so that subsequent async focus will work
                  fakeInput.focus();

            }
             
         script.onload = () => {   
                    
          

          if (callbackDefer ) callbackDefer(currentElem);
        };
    }
    else{
        console.log("Findify Scripts are already loaded. Do nothing");
    }
}



$(document).on('click','.header_top .location-information .fixed-search .header-top-search', function(e){

    var currentElem = $(this);

    headerSeachBar(currentElem,callbackDefer);
});

const search_term = [];
$("form[action='/search']").on("submit", function() {
    var searched_term = $(this).find(".header-top-search").val();
    search_term.push(searched_term);

    window.dataLayer = window.dataLayer || [];
    if(search_term.length === 1) {
        window.dataLayer.push({ 'ecommerce': null });
        window.dataLayer.push({
          'event': 'search',
          'ecommerce': {
            'search_term': search_term
          }
        });
    } else {
        for(let i = 0; i < window.dataLayer.length; i ++) {
            if(window.dataLayer[i].event === 'search' ) {
                window.dataLayer[i].ecommerce.search_term = search_term;
            }
        }
    }
});


